<template>
  <div class="preset-shop">
    <!-- 顶部导航 -->
    <header class="header">
      <button class="back-btn" @click="goBack">← 返回主页</button>
      <h2>LR 预设商店</h2>
    </header>

    <!--  banner -->
    <section class="banner">
      <h1>高级质感 LR 预设合集</h1>
      <p>一键出片 | 古风 | 电影感 | 人像 | 日系</p>
    </section>

    <!-- 预设列表 -->
    <section class="presets">
      <h2>全部预设</h2>
      <div class="grid">
        <div class="card" v-for="(item, idx) in presets" :key="idx">
          <img :src="item.cover" alt="" class="cover" />
          <div class="info">
            <h3>{{ item.name }}</h3>
            <p class="desc">{{ item.desc }}</p>
            <p class="price">{{ item.price }} 元</p>
            <button class="buy-btn">咨询购买</button>
          </div>
        </div>
      </div>
    </section>

    <!-- 效果对比 -->
    <section class="compare">
      <h2>效果对比</h2>
      <div class="compare-row">
        <div><img src="https://picsum.photos/600/800?before" alt="修前"></div>
        <div><img src="https://picsum.photos/600/800?after" alt="修后"></div>
      </div>
    </section>

    <!-- 购买咨询 -->
    <section class="contact">
      <h2>购买咨询</h2>
      <form action="https://formspree.io/f/xxxx" method="POST">
        <input type="text" name="username" placeholder="你的姓名" required />
        <input type="text" name="wechat" placeholder="你的微信" required />
        <select name="preset">
          <option>古风暗调预设</option>
          <option>电影感人像预设</option>
          <option>日系清新预设</option>
          <option>全套终身打包</option>
        </select>
        <button type="submit">提交购买</button>
      </form>
    </section>

    <footer>
      <p>© 2025 预设商店 | 微信：your-wechat</p>
    </footer>
  </div>
</template>

<script setup>
const goBack = () => {
  window.history.back()
}

const presets = [
  {
    name: "古风暗调预设",
    desc: "适合汉服、古风、武侠、暗调氛围",
    price: 19.9,
    cover: "https://picsum.photos/600/800?11"
  },
  {
    name: "电影感人像预设",
    desc: "人像质感、电影色调、高级情绪风",
    price: 19.9,
    cover: "https://picsum.photos/600/800?12"
  },
  {
    name: "日系清新预设",
    desc: "清新干净、明亮通透、日常写真",
    price: 19.9,
    cover: "https://picsum.photos/600/800?13"
  },
  {
    name: "全套终身打包",
    desc: "全部预设 + 后续更新 + 教程",
    price: 39.9,
    cover: "https://picsum.photos/600/800?14"
  }
]
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, sans-serif;
}

.header {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 20px 6vw;
  background: #fff;
  border-bottom: 1px solid #eee;
  position: sticky;
  top: 0;
  z-index: 99;
}

.back-btn {
  padding: 8px 14px;
  background: #222;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.banner {
  padding: 60px 6vw;
  background: #f7f7f7;
  text-align: center;
}

.banner h1 {
  font-size: 28px;
  margin-bottom: 10px;
}

.banner p {
  color: #666;
  font-size: 16px;
}

.presets {
  padding: 60px 6vw;
}

.presets h2 {
  text-align: center;
  font-size: 26px;
  margin-bottom: 40px;
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 28px;
}

.card {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.05);
}

.cover {
  width: 100%;
  height: 380px;
  object-fit: cover;
}

.info {
  padding: 20px;
}

.desc {
  color: #666;
  margin: 6px 0;
  font-size: 14px;
}

.price {
  color: #e63946;
  font-weight: bold;
  margin: 8px 0;
}

.buy-btn {
  padding: 10px 16px;
  background: #222;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.compare {
  padding: 60px 6vw;
  background: #fafafa;
}

.compare h2 {
  text-align: center;
  font-size: 26px;
  margin-bottom: 30px;
}

.compare-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.compare-row img {
  width: 100%;
  border-radius: 12px;
}

.contact {
  padding: 60px 6vw;
}

.contact h2 {
  text-align: center;
  font-size: 26px;
  margin-bottom: 30px;
}

form {
  max-width: 500px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

input,
select {
  padding: 14px;
  border: 1px solid #ddd;
  border-radius: 10px;
  font-size: 15px;
}

form button {
  padding: 16px;
  background: #222;
  color: white;
  border: none;
  border-radius: 10px;
  cursor: pointer;
}

footer {
  background: #111;
  color: white;
  text-align: center;
  padding: 30px 0;
  font-size: 14px;
}
</style>
